module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "textSection"
  }, [_c('h1', [_vm._v("Les ateliers présentiels - Du numérique à la vraie vie")]), _vm._v(" "), _c('p', [_vm._v("\n        Savoir Être Aidant est une formation gratuite et ouverte à tous dont l’objectif est de permettre à vous, aidants, d'appréhender votre rôle avec plus de sérénité.\n    ")]), _vm._v(" "), _c('p', [_vm._v("            \n        C’est pourquoi nous vous proposons, en parallèle des vidéos de formations, des ateliers présentiels qui débuteront en octobre 2017 et qui se poursuivront tout au long de l’année 2018 sur le territoire de la Seine-Amont (Ivry-sur-Seine, Vitry-sur-Seine, Choisy-le-Roi).\n    ")]), _vm._v(" "), _c('p', [_vm._v("            \n        Pour participer gratuitement à ces ateliers de formation, il suffit de vous inscrire en nous contactant soit sur "), _c('a', {
    attrs: {
      "href": "mailto:contact@savoiretreaidant.fr"
    }
  }, [_vm._v("contact@savoiretreaidant.fr")]), _vm._v(" ou en ou appelant au 07.67.42.33.91.\n    ")]), _vm._v(" "), _c('p', [_vm._v("            \n        Retrouvez l’ensemble du programme de formation présentielle ci-dessous :\n    ")]), _vm._v(" "), _c('img', {
    staticClass: "workshops-image",
    attrs: {
      "src": "/static/img/workshops_2019.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-311e1971"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Events.vue
// module id = 443
// module chunks = 1